import styles from "./styles.module.scss";
import { CoachingToolsItem } from "../Item";
import { CoachingToolsReviewItem } from "../ReviewItem";
import { FileChartColumnIncreasing, Star, Award } from "lucide-react";
import { VideoSidebar, PlayerBadgesModalMode } from "common/src/gamePage/types";
import { useGameStore } from "common/src/gamePage/store";
import { useEditStore } from "common/src/gamePage/edit-store";
import { _ } from "i18n";
import { useGetReviewsSummary } from "common/src/gamePage/hooks/useGetReviewsSummary";

export const CoachingToolsList = () => {
	const { gameData, setSidebar } = useGameStore();
	const { setPlayerRatingModal, setPlayerBadgesModal } = useEditStore();
	const { data } = useGetReviewsSummary();

	if (gameData == null) {
		return null;
	}

	const canAttachReviews = gameData.homeGameTeam.permissions.reviewEdit || gameData.awayGameTeam.permissions.reviewEdit;
	const canEditRatingsAndBadges =
		gameData.homeGameTeam.permissions.ratingBadgeEdit || gameData.awayGameTeam.permissions.ratingBadgeEdit;
	const canWriteReviews = gameData.permissions.showAiCoachReview;

	const handleTeamAndPlayerReviewsClick = () => {
		setSidebar(VideoSidebar.TeamPlayerReviews);
	};

	const handleRatePlayersClick = () => {
		setPlayerRatingModal({ show: true, id: 0, name: "", rating: null });
	};

	const handleAssignBadgesClick = () => {
		setPlayerBadgesModal({
			show: true,
			id: 0,
			name: "",
			badgeIds: [],
			mode: PlayerBadgesModalMode.Save,
		});
	};

	return (
		<div className={styles.list}>
			{canAttachReviews && canWriteReviews && (
				<CoachingToolsReviewItem
					name={_("game.coachingTools.list.teamAndPlayerReviews")}
					icon={FileChartColumnIncreasing}
					onClick={handleTeamAndPlayerReviewsClick}
					teamReview={data?.data ? { sent: data.data.teamReviewSent ? 1 : 0, total: 1 } : undefined}
					playerReviews={data?.data ? { sent: data.data.playerReviews.sent, total: data.data.playerReviews.total } : undefined}
				/>
			)}
			{canEditRatingsAndBadges && (
				<>
					<CoachingToolsItem name={_("game.coachingTools.list.ratePlayers")} icon={Star} onClick={handleRatePlayersClick} />
					<CoachingToolsItem name={_("game.coachingTools.list.assignBadges")} icon={Award} onClick={handleAssignBadgesClick} />
				</>
			)}
		</div>
	);
};
